/**
 * MEU ERP API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { SaSheetWorkingTimeData } from '../model/saSheetWorkingTimeData';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class SaSheetWorkingTimeDataService {

    protected basePath = 'https://gateway.dev.meu-solutions.com/staginganawork';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param sheetId 
     * @param Filters 
     * @param Sorts 
     * @param Page 
     * @param PageSize 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSaSheetsSheetIdAllWorkingTimeGet(sheetId: string, Filters?: string, Sorts?: string, Page?: number, PageSize?: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiSaSheetsSheetIdAllWorkingTimeGet(sheetId: string, Filters?: string, Sorts?: string, Page?: number, PageSize?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiSaSheetsSheetIdAllWorkingTimeGet(sheetId: string, Filters?: string, Sorts?: string, Page?: number, PageSize?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiSaSheetsSheetIdAllWorkingTimeGet(sheetId: string, Filters?: string, Sorts?: string, Page?: number, PageSize?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sheetId === null || sheetId === undefined) {
            throw new Error('Required parameter sheetId was null or undefined when calling apiSaSheetsSheetIdAllWorkingTimeGet.');
        }





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (Filters !== undefined && Filters !== null) {
            queryParameters = queryParameters.set('Filters', <any>Filters);
        }
        if (Sorts !== undefined && Sorts !== null) {
            queryParameters = queryParameters.set('Sorts', <any>Sorts);
        }
        if (Page !== undefined && Page !== null) {
            queryParameters = queryParameters.set('Page', <any>Page);
        }
        if (PageSize !== undefined && PageSize !== null) {
            queryParameters = queryParameters.set('PageSize', <any>PageSize);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/api/saSheets/${encodeURIComponent(String(sheetId))}/allWorkingTime`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param sheetId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSaSheetsSheetIdSyncWorkingTimeForAllPost(sheetId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiSaSheetsSheetIdSyncWorkingTimeForAllPost(sheetId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiSaSheetsSheetIdSyncWorkingTimeForAllPost(sheetId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiSaSheetsSheetIdSyncWorkingTimeForAllPost(sheetId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sheetId === null || sheetId === undefined) {
            throw new Error('Required parameter sheetId was null or undefined when calling apiSaSheetsSheetIdSyncWorkingTimeForAllPost.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('post',`${this.basePath}/api/saSheets/${encodeURIComponent(String(sheetId))}/syncWorkingTimeForAll`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param sheetStaffId 
     * @param Filters 
     * @param Sorts 
     * @param Page 
     * @param PageSize 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSaSheetsSheetStaffsSheetStaffIdAbsentRequestsGet(sheetStaffId: string, Filters?: string, Sorts?: string, Page?: number, PageSize?: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiSaSheetsSheetStaffsSheetStaffIdAbsentRequestsGet(sheetStaffId: string, Filters?: string, Sorts?: string, Page?: number, PageSize?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiSaSheetsSheetStaffsSheetStaffIdAbsentRequestsGet(sheetStaffId: string, Filters?: string, Sorts?: string, Page?: number, PageSize?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiSaSheetsSheetStaffsSheetStaffIdAbsentRequestsGet(sheetStaffId: string, Filters?: string, Sorts?: string, Page?: number, PageSize?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sheetStaffId === null || sheetStaffId === undefined) {
            throw new Error('Required parameter sheetStaffId was null or undefined when calling apiSaSheetsSheetStaffsSheetStaffIdAbsentRequestsGet.');
        }





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (Filters !== undefined && Filters !== null) {
            queryParameters = queryParameters.set('Filters', <any>Filters);
        }
        if (Sorts !== undefined && Sorts !== null) {
            queryParameters = queryParameters.set('Sorts', <any>Sorts);
        }
        if (Page !== undefined && Page !== null) {
            queryParameters = queryParameters.set('Page', <any>Page);
        }
        if (PageSize !== undefined && PageSize !== null) {
            queryParameters = queryParameters.set('PageSize', <any>PageSize);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/api/saSheets/sheetStaffs/${encodeURIComponent(String(sheetStaffId))}/absentRequests`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param sheetStaffId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSaSheetsSheetStaffsSheetStaffIdAutoGenerateWorkingTimePost(sheetStaffId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiSaSheetsSheetStaffsSheetStaffIdAutoGenerateWorkingTimePost(sheetStaffId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiSaSheetsSheetStaffsSheetStaffIdAutoGenerateWorkingTimePost(sheetStaffId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiSaSheetsSheetStaffsSheetStaffIdAutoGenerateWorkingTimePost(sheetStaffId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sheetStaffId === null || sheetStaffId === undefined) {
            throw new Error('Required parameter sheetStaffId was null or undefined when calling apiSaSheetsSheetStaffsSheetStaffIdAutoGenerateWorkingTimePost.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('post',`${this.basePath}/api/saSheets/sheetStaffs/${encodeURIComponent(String(sheetStaffId))}/autoGenerateWorkingTime`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param sheetStaffId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSaSheetsSheetStaffsSheetStaffIdSaSheetWorkingTimeDataEditByListPut(sheetStaffId: string, body?: Array<SaSheetWorkingTimeData>, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiSaSheetsSheetStaffsSheetStaffIdSaSheetWorkingTimeDataEditByListPut(sheetStaffId: string, body?: Array<SaSheetWorkingTimeData>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiSaSheetsSheetStaffsSheetStaffIdSaSheetWorkingTimeDataEditByListPut(sheetStaffId: string, body?: Array<SaSheetWorkingTimeData>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiSaSheetsSheetStaffsSheetStaffIdSaSheetWorkingTimeDataEditByListPut(sheetStaffId: string, body?: Array<SaSheetWorkingTimeData>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sheetStaffId === null || sheetStaffId === undefined) {
            throw new Error('Required parameter sheetStaffId was null or undefined when calling apiSaSheetsSheetStaffsSheetStaffIdSaSheetWorkingTimeDataEditByListPut.');
        }


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/api/saSheets/sheetStaffs/${encodeURIComponent(String(sheetStaffId))}/saSheetWorkingTimeData/editByList`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param sheetStaffId 
     * @param Filters 
     * @param Sorts 
     * @param Page 
     * @param PageSize 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSaSheetsSheetStaffsSheetStaffIdSaSheetWorkingTimeDataGet(sheetStaffId: string, Filters?: string, Sorts?: string, Page?: number, PageSize?: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiSaSheetsSheetStaffsSheetStaffIdSaSheetWorkingTimeDataGet(sheetStaffId: string, Filters?: string, Sorts?: string, Page?: number, PageSize?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiSaSheetsSheetStaffsSheetStaffIdSaSheetWorkingTimeDataGet(sheetStaffId: string, Filters?: string, Sorts?: string, Page?: number, PageSize?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiSaSheetsSheetStaffsSheetStaffIdSaSheetWorkingTimeDataGet(sheetStaffId: string, Filters?: string, Sorts?: string, Page?: number, PageSize?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sheetStaffId === null || sheetStaffId === undefined) {
            throw new Error('Required parameter sheetStaffId was null or undefined when calling apiSaSheetsSheetStaffsSheetStaffIdSaSheetWorkingTimeDataGet.');
        }





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (Filters !== undefined && Filters !== null) {
            queryParameters = queryParameters.set('Filters', <any>Filters);
        }
        if (Sorts !== undefined && Sorts !== null) {
            queryParameters = queryParameters.set('Sorts', <any>Sorts);
        }
        if (Page !== undefined && Page !== null) {
            queryParameters = queryParameters.set('Page', <any>Page);
        }
        if (PageSize !== undefined && PageSize !== null) {
            queryParameters = queryParameters.set('PageSize', <any>PageSize);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/api/saSheets/sheetStaffs/${encodeURIComponent(String(sheetStaffId))}/saSheetWorkingTimeData`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param sheetStaffId 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSaSheetsSheetStaffsSheetStaffIdSaSheetWorkingTimeDataIdDelete(sheetStaffId: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiSaSheetsSheetStaffsSheetStaffIdSaSheetWorkingTimeDataIdDelete(sheetStaffId: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiSaSheetsSheetStaffsSheetStaffIdSaSheetWorkingTimeDataIdDelete(sheetStaffId: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiSaSheetsSheetStaffsSheetStaffIdSaSheetWorkingTimeDataIdDelete(sheetStaffId: string, id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sheetStaffId === null || sheetStaffId === undefined) {
            throw new Error('Required parameter sheetStaffId was null or undefined when calling apiSaSheetsSheetStaffsSheetStaffIdSaSheetWorkingTimeDataIdDelete.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling apiSaSheetsSheetStaffsSheetStaffIdSaSheetWorkingTimeDataIdDelete.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/api/saSheets/sheetStaffs/${encodeURIComponent(String(sheetStaffId))}/saSheetWorkingTimeData/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param sheetStaffId 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSaSheetsSheetStaffsSheetStaffIdSaSheetWorkingTimeDataIdGet(sheetStaffId: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiSaSheetsSheetStaffsSheetStaffIdSaSheetWorkingTimeDataIdGet(sheetStaffId: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiSaSheetsSheetStaffsSheetStaffIdSaSheetWorkingTimeDataIdGet(sheetStaffId: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiSaSheetsSheetStaffsSheetStaffIdSaSheetWorkingTimeDataIdGet(sheetStaffId: string, id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sheetStaffId === null || sheetStaffId === undefined) {
            throw new Error('Required parameter sheetStaffId was null or undefined when calling apiSaSheetsSheetStaffsSheetStaffIdSaSheetWorkingTimeDataIdGet.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling apiSaSheetsSheetStaffsSheetStaffIdSaSheetWorkingTimeDataIdGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/api/saSheets/sheetStaffs/${encodeURIComponent(String(sheetStaffId))}/saSheetWorkingTimeData/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param sheetStaffId 
     * @param id 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSaSheetsSheetStaffsSheetStaffIdSaSheetWorkingTimeDataIdPut(sheetStaffId: string, id: string, body?: SaSheetWorkingTimeData, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiSaSheetsSheetStaffsSheetStaffIdSaSheetWorkingTimeDataIdPut(sheetStaffId: string, id: string, body?: SaSheetWorkingTimeData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiSaSheetsSheetStaffsSheetStaffIdSaSheetWorkingTimeDataIdPut(sheetStaffId: string, id: string, body?: SaSheetWorkingTimeData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiSaSheetsSheetStaffsSheetStaffIdSaSheetWorkingTimeDataIdPut(sheetStaffId: string, id: string, body?: SaSheetWorkingTimeData, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sheetStaffId === null || sheetStaffId === undefined) {
            throw new Error('Required parameter sheetStaffId was null or undefined when calling apiSaSheetsSheetStaffsSheetStaffIdSaSheetWorkingTimeDataIdPut.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling apiSaSheetsSheetStaffsSheetStaffIdSaSheetWorkingTimeDataIdPut.');
        }


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/api/saSheets/sheetStaffs/${encodeURIComponent(String(sheetStaffId))}/saSheetWorkingTimeData/${encodeURIComponent(String(id))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param sheetStaffId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSaSheetsSheetStaffsSheetStaffIdSaSheetWorkingTimeDataListPost(sheetStaffId: string, body?: Array<SaSheetWorkingTimeData>, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiSaSheetsSheetStaffsSheetStaffIdSaSheetWorkingTimeDataListPost(sheetStaffId: string, body?: Array<SaSheetWorkingTimeData>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiSaSheetsSheetStaffsSheetStaffIdSaSheetWorkingTimeDataListPost(sheetStaffId: string, body?: Array<SaSheetWorkingTimeData>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiSaSheetsSheetStaffsSheetStaffIdSaSheetWorkingTimeDataListPost(sheetStaffId: string, body?: Array<SaSheetWorkingTimeData>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sheetStaffId === null || sheetStaffId === undefined) {
            throw new Error('Required parameter sheetStaffId was null or undefined when calling apiSaSheetsSheetStaffsSheetStaffIdSaSheetWorkingTimeDataListPost.');
        }


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/saSheets/sheetStaffs/${encodeURIComponent(String(sheetStaffId))}/saSheetWorkingTimeDataList`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param sheetStaffId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSaSheetsSheetStaffsSheetStaffIdSaSheetWorkingTimeDataPost(sheetStaffId: string, body?: SaSheetWorkingTimeData, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiSaSheetsSheetStaffsSheetStaffIdSaSheetWorkingTimeDataPost(sheetStaffId: string, body?: SaSheetWorkingTimeData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiSaSheetsSheetStaffsSheetStaffIdSaSheetWorkingTimeDataPost(sheetStaffId: string, body?: SaSheetWorkingTimeData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiSaSheetsSheetStaffsSheetStaffIdSaSheetWorkingTimeDataPost(sheetStaffId: string, body?: SaSheetWorkingTimeData, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sheetStaffId === null || sheetStaffId === undefined) {
            throw new Error('Required parameter sheetStaffId was null or undefined when calling apiSaSheetsSheetStaffsSheetStaffIdSaSheetWorkingTimeDataPost.');
        }


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/saSheets/sheetStaffs/${encodeURIComponent(String(sheetStaffId))}/saSheetWorkingTimeData`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSaSheetsSheetStaffsSyncWorkingTimeDataByListPost(body?: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiSaSheetsSheetStaffsSyncWorkingTimeDataByListPost(body?: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiSaSheetsSheetStaffsSyncWorkingTimeDataByListPost(body?: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiSaSheetsSheetStaffsSyncWorkingTimeDataByListPost(body?: Array<string>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/saSheets/sheetStaffs/syncWorkingTimeDataByList`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
